<template>
    <CardPage :section="2" :page="14" :nextFunction="save">
        <template v-slot:image>
            <v-alert :value="error" type="error">{{ error }}</v-alert>
            <div class="bio-image" @click.stop="selectImage()" v-ripple>
                <ResponsiveImage flex="xs12" :src="photo" :min-height="200">
                    <v-btn outline large color="primary">
                        <v-icon left>add_a_photo</v-icon>
                        Tap to add your photo!
                    </v-btn>
                </ResponsiveImage>
            </div>
            <input type="file" class="d-none" ref="imageUpload" accept="image/*" @change="imageUpload" />
        </template>
        <p class="title primary bio-title pa-3">{{ name }}</p>
        <p>
            <span v-for="(fact, index) in selectedFacts" :key="index">{{ factText(fact.id, index) }} </span>
        </p>
        <p class="mt-5">If you’d like to, take a screenshot of your bio and save to remember your story, accomplishments and dreams!</p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            error: ''
        };
    },
    computed: {
        name: get('preferences@name'),
        photo: get('photo'),
        selectedFacts: get('section2/selectedFacts'),
        factText: get('section2/factText')
    },
    methods: {
        selectImage() {
            this.$refs.imageUpload.click();
        },
        imageUpload(e) {
            this.error = '';

            const files = e.target.files;
            if (files[0] !== undefined) {
                var formData = new FormData();
                formData.append('image', files[0]);
                this.$api
                    .post('/image/preview', formData)
                    .then(response => {
                        this.$store.set('photo', response.data.src);
                    })
                    .catch(err => {
                        if (413 === err.response.status) {
                            this.error = 'Image too large, please select a smaller image';
                        } else {
                            this.error = 'Error processing image, please try again';
                        }
                    });
            }
        },
        save() {
            this.$api.post('/photo', { src: this.photo });
        }
    }
};
</script>

<style scoped>
.bio-image {
    margin: -4em 0;
}
.bio-title {
    margin: 1em -0.8em;
    color: #ffffff;
    text-align: center;
}
</style>
